import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    if (!this.isLoginedIn()) {
      return false;
      // this.router.navigate(['']);
    }
    let quyen = +localStorage.getItem('quyen')!;
    if (quyen == null || quyen == undefined) {
      quyen = -1;
    }
    switch (state.url) {
      case "/nhansu": {
        if (quyen != 2 && quyen != 1) {
          this.router.navigate(['/home']);
          return false;
        }
      } break;
      case "/loaihopdong": {
        if (quyen != 2 && quyen != 1) {
          this.router.navigate(['/home']);
          return false;
        }
      } break;
      case "/nguoiyeucau": {
        if (quyen != 2 && quyen != 1) {
          this.router.navigate(['/home']);
          return false;
        }
      } break;

      default: { 
        return true;
      } break;
    }
    return true;
  }
  public isLoginedIn(): boolean {
    let status = false;
    if (localStorage.getItem('isLoginedIn') === 'true') {
      status = true;
    }
    else {
      status = false;
    }
    return status;
  }
}
